/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContentItemDetail = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M3 2H2v20h7v-2H4V4h16v8h2V2h-1zm3 6h3V6H6zm5 0h7V6h-7zm-5 4h3v-2H6zm5 0h7v-2h-7zm-5 4h3v-2H6zm15.836 1.452c-.745-1.137-2.304-2.753-4.405-3.28a5.624 5.624 0 0 0-3.531.257c-1.242.5-2.476 1.45-3.679 2.944l-.456.567.399.608c.745 1.137 2.304 2.752 4.405 3.28a5.624 5.624 0 0 0 3.531-.257c1.242-.5 2.476-1.45 3.679-2.944l.456-.567zm-6.78 2.436c-1.139-.286-2.122-1.083-2.774-1.847.856-.932 1.655-1.471 2.365-1.757a3.627 3.627 0 0 1 2.297-.172c1.139.286 2.122 1.083 2.774 1.847-.856.932-1.655 1.471-2.365 1.757a3.627 3.627 0 0 1-2.297.172zM16 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgContentItemDetail as ContentItemDetail };
